export const isValidResponse = res => {
  if (!res) {
    return false
  }

  return res
}

export const strEmpty = (str = '') => {
  return str.length === 0 || !str.trim() || /^\s*$/.test(str)
}

export const valideWhiteSpace = (str = '') => {
  return /^(.*\s+.*)+$/.test(str)
}

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
